module.exports = __webpack_public_path__ + "static/karibik-6c29b9a02ef167b0e46e86e2712d3f75.svg";